export default function ChartContainer({ title, description, children, actions }) {
  return (
    <section className="soft-card p-5 sm:p-8">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div><p className="text-xs font-black uppercase tracking-[0.18em] text-blue-700">Interactive infographic</p><h2 className="mt-2 text-2xl font-black text-neutral-950 sm:text-3xl">{title}</h2><p className="mt-3 max-w-3xl leading-7 text-neutral-600">{description}</p></div>
        {actions}
      </div>
      <div className="mt-7">{children}</div>
    </section>
  );
}
